export default __webpack_public_path__ + "static/media/coresanscr65-webfont.4b512a97.woff2";